import { capitalize, splitByUppercase } from '../../../utils/text.js'
import { CodeInput } from '../../CodeInput/index.js'

export const JsonType = ({ value, onChange, schemaProp, name }) => {
  const { title, description, readOnly, max, format } = schemaProp

  try {
    try {
      if (typeof value === 'string') {
        value = JSON.parse(value)
      }
    } catch {}

    if (typeof value !== 'string') {
      value = JSON.stringify(value, null, 2)
    }
  } catch (err) {
    value = value?.toString()
  }

  return (
    <CodeInput
      language="json"
      value={value}
      onChange={(v) => {
        if (onChange) {
          onChange(v, name)
        }
      }}
      label={capitalize(splitByUppercase(title ?? name))}
      description={description}
      disabled={readOnly}
    />
  )
}
